<template>
    <cursor-index></cursor-index>
    <layout-header></layout-header>

    <home-banner></home-banner>

    <home-services></home-services>

    <home-popular></home-popular>

    <home-work></home-work>

    <home-provider></home-provider>

    <home-testimonial></home-testimonial>

    <home-blog></home-blog>

    <link-section></link-section>

    <home-footer></home-footer>
</template>